<template>
  <div
    class="data-table"
    :class="{ subtable: type === 'subtable' }"
  >
    <div
      ref="headerOfList"
      class="data-table-new__header__row"
      :class="{ 'data-table-new__header__row--sticky': stickyActivated }"
    >
      <data-table-header
        v-for="(item, index) in header"
        :key="index"
        :header="item"
        :sort-order="sortState.value === item.value ? sortState.order : ''"
        :hint="item?.hint"
        @sort="handleSort"
      />
    </div>

    <slot />
  </div>
</template>

<script>
import DataTableHeader from "./DataTableHeader.vue";

export default {
  name: "DataTable",
  components: {
    DataTableHeader
  },
  props: {
    header: {
      type: Array,
      default: () => []
    },
    type: {
      default: "regular",
      type: String
    },
    isSticky: Boolean
  },
  data() {
    return {
      stickyActivated: false,
      sortState: {
        value: '',
        order: ''
      }
    };
  },
  created() {
    if (this.isSticky) window.addEventListener("scroll", this.turnHeaderListFixed);
    if (this.header.length > 0) {
      this.sortState = { value: this.header[0].value, order: '' };
    }
  },
  beforeDestroy() {
    if (this.isSticky) window.removeEventListener("scroll", this.turnHeaderListFixed);
  },
  methods: {
    turnHeaderListFixed() {
      const headerPosition = this.$refs.headerOfList.offsetTop - 58;
      this.stickyActivated = window.pageYOffset > headerPosition;
    },
    handleSort(sortState) {
      this.sortState = sortState;
      this.$emit("sort", sortState);
    }
  }
};
</script>

<style lang="scss" scoped>
.data-table-new {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  &__header__row {
    display: flex;
    flex-direction: row;

    &--sticky {
      position: fixed;
      top: 58px;
      padding: 0 12em;
      width: calc(100% - 50px);
      min-width: 900px;
      margin-left: 50px;
      margin-top: 0;
      left: 0;
      background: #ebebeb;
    }
  }
}
</style>
